import InfoPanel from '../../components/memo.elements/info.panel';
import TariffStatus from './tariff.status';
import './home.scss';
import useGlobal from '../../../store';
import { formatDate } from '../../scripts/helpers/get.date';
import useReloadDummy from '../../scripts/hooks/use.reload.dummy';
import { useEffect } from 'react';
import Loading from '../../components/loading';

const HomePage = () => {

  const [ globalState, globalActions ] = useGlobal();

  const { 
    
    isDataLoaded,
    
    parsingDate,
    parsingFolder,
    parsingNextTime,

    user, 
    subscribeDateEnd, 
    subscribeRemainingDays, 

  } = globalState;

  const [ Dummy, reloadDummy ] = useReloadDummy();

  useEffect(() => {

    reloadDummy();

  }, [ subscribeDateEnd, subscribeRemainingDays ])

  return ( !isDataLoaded ? <Loading /> :

    <div className = 'container home'>

      <Dummy />

      <InfoPanel className = 'home__infopanel'>

        <p className = 'home__infopanel__title home__infopanel__text__16'>

          Добро пожаловать, <br />
          { user.email } <br />
          <br />

          <span className = 'home__infopanel__title home__infopanel__text__15'>   
            { subscribeRemainingDays > 0 ? 'Ваш доступ активен до:' : 'Ваш доступ был активен до:' }
          </span>

        </p>

        <p className = 'home__infopanel__text home__infopanel__text__17'>{ formatDate(subscribeDateEnd) }</p>

      </InfoPanel>

      <TariffStatus 
      
        parsingDate = { parsingDate }
        parsingFolder = { parsingFolder }
        parsingNextTime = { parsingNextTime }
        isTariffActive = { subscribeRemainingDays > 0 } 
        
      />

    </div>

  );

};

export default HomePage;